(() => {
  const MINIMUM = 6;
  const MESSAGE =
    "La quantité minimale pour ce produit est de 6 unités.";

  function forceMinimum(input, showMessage = false) {
    if (!input) return;

    input.min = String(MINIMUM);

    const quantity = Number.parseInt(input.value, 10);

    if (!Number.isFinite(quantity) || quantity < MINIMUM) {
      input.value = String(MINIMUM);
      input.setAttribute("value", String(MINIMUM));

      if (showMessage) {
        alert(MESSAGE);
      }
    }
  }

  /*
   * ÜRÜN SAYFASI
   * Yalnızca minimum-6 etiketi bulunan üründe çalışır.
   */
  function initialiseProductPage() {
    if (window.minimum6Enabled !== true) {
      return;
    }

    const productArea = document.querySelector(
      "product-info, .product__info-container"
    );

    if (!productArea) return;

    const quantityInputs = productArea.querySelectorAll(
      'input[name="quantity"], input.quantity__input'
    );

    quantityInputs.forEach((input) => {
      input.dataset.minimum6 = "true";
      forceMinimum(input);

      if (input.dataset.minimum6Events === "true") {
        return;
      }

      input.dataset.minimum6Events = "true";

      input.addEventListener(
        "input",
        (event) => {
          const value = Number.parseInt(input.value, 10);

          if (!Number.isFinite(value) || value < MINIMUM) {
            event.preventDefault();
            event.stopImmediatePropagation();
            forceMinimum(input);
          }
        },
        true
      );

      input.addEventListener(
        "change",
        (event) => {
          const value = Number.parseInt(input.value, 10);

          if (!Number.isFinite(value) || value < MINIMUM) {
            event.preventDefault();
            event.stopImmediatePropagation();
            forceMinimum(input, true);
          }
        },
        true
      );
    });

    productArea
      .querySelectorAll('form[action*="/cart/add"]')
      .forEach((form) => {
        let marker = form.querySelector(
          'input[name="properties[_minimum6]"]'
        );

        if (!marker) {
          marker = document.createElement("input");
          marker.type = "hidden";
          marker.name = "properties[_minimum6]";
          marker.value = "true";
          form.appendChild(marker);
        }

        if (form.dataset.minimum6FormReady === "true") {
          return;
        }

        form.dataset.minimum6FormReady = "true";

        form.addEventListener(
          "submit",
          (event) => {
            const input = productArea.querySelector(
              'input[name="quantity"], input.quantity__input'
            );

            if (!input) return;

            const value = Number.parseInt(input.value, 10);

            if (!Number.isFinite(value) || value < MINIMUM) {
              event.preventDefault();
              event.stopImmediatePropagation();
              forceMinimum(input, true);
            }
          },
          true
        );
      });
  }

  /*
   * DRAWER CART
   * Sepette yalnızca _minimum6 özelliği bulunan ürünü korur.
   */
  let drawerScanRunning = false;
  let drawerScanTimer;

  async function markProtectedDrawerItems() {
    if (drawerScanRunning) return;

    const drawer = document.querySelector(
      "cart-drawer, #CartDrawer"
    );

    if (!drawer) return;

    drawerScanRunning = true;

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          headers: {
            Accept: "application/json"
          }
        }
      );

      if (!response.ok) return;

      const cart = await response.json();

      cart.items.forEach((item, index) => {
        const line = index + 1;

        const isMinimum6 =
          item.properties &&
          String(item.properties._minimum6) === "true";

        const selectors = [
          `#Drawer-quantity-${line}`,
          `#CartDrawer-quantity-${line}`,
          `#CartDrawer input[data-index="${line}"]`,
          `cart-drawer input[data-index="${line}"]`
        ];

        const input = drawer.querySelector(
          selectors.join(", ")
        );

        if (!input) return;

        if (isMinimum6) {
          input.dataset.minimum6 = "true";
          forceMinimum(input);
        } else {
          delete input.dataset.minimum6;
          input.removeAttribute("min");
        }
      });
    } catch (error) {
      console.error("Minimum quantity drawer error:", error);
    } finally {
      drawerScanRunning = false;
    }
  }

  function scheduleDrawerScan() {
    clearTimeout(drawerScanTimer);

    drawerScanTimer = setTimeout(() => {
      markProtectedDrawerItems();
    }, 250);
  }

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest(
        "cart-drawer quantity-input button, " +
        "#CartDrawer quantity-input button"
      );

      if (!button) return;

      const quantityInput = button
        .closest("quantity-input")
        ?.querySelector(
          'input[name="updates[]"], input.quantity__input'
        );

      if (
        !quantityInput ||
        quantityInput.dataset.minimum6 !== "true"
      ) {
        scheduleDrawerScan();
        return;
      }

      const isMinusButton =
        button.name === "minus" ||
        button.querySelector(
          'svg, .icon-minus'
        )?.classList.contains("icon-minus");

      const value = Number.parseInt(
        quantityInput.value,
        10
      );

      if (isMinusButton && value <= MINIMUM) {
        event.preventDefault();
        event.stopImmediatePropagation();
        forceMinimum(quantityInput, true);
      }
    },
    true
  );

  document.addEventListener(
    "input",
    (event) => {
      const input = event.target.closest(
        "cart-drawer input.quantity__input, " +
        "#CartDrawer input.quantity__input, " +
        "cart-drawer input[name='updates[]'], " +
        "#CartDrawer input[name='updates[]']"
      );

      if (
        !input ||
        input.dataset.minimum6 !== "true"
      ) {
        return;
      }

      const value = Number.parseInt(input.value, 10);

      if (!Number.isFinite(value) || value < MINIMUM) {
        event.preventDefault();
        event.stopImmediatePropagation();
        forceMinimum(input);
      }
    },
    true
  );

  document.addEventListener(
    "change",
    (event) => {
      const input = event.target.closest(
        "cart-drawer input.quantity__input, " +
        "#CartDrawer input.quantity__input, " +
        "cart-drawer input[name='updates[]'], " +
        "#CartDrawer input[name='updates[]']"
      );

      if (
        !input ||
        input.dataset.minimum6 !== "true"
      ) {
        return;
      }

      const value = Number.parseInt(input.value, 10);

      if (!Number.isFinite(value) || value < MINIMUM) {
        event.preventDefault();
        event.stopImmediatePropagation();
        forceMinimum(input, true);
      }
    },
    true
  );

  function initialise() {
    initialiseProductPage();
    scheduleDrawerScan();
  }

  document.addEventListener(
    "DOMContentLoaded",
    initialise
  );

  document.addEventListener(
    "shopify:section:load",
    initialise
  );

  const observer = new MutationObserver(() => {
    initialiseProductPage();
    scheduleDrawerScan();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();